import EventActivityVue from '@/views/sm/event-activity/event-activity.vue';

const basePath = '/sm/event-activity';
const role = 'sm'; // 角色身份

export const SM_EVENT_ACTIVITY_INDEX = 'sm-event-activity-index';
export const SM_EVENT_ACTIVITY_EDIT = 'sm-event-activity-edit';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: EventActivityVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: SM_EVENT_ACTIVITY_INDEX,
      props: true,
      component: () => import(
        /* webpackChunkName: "event-activity-create" */
        `@/views/${role}/event-activity/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/edit/:id`,
      name: SM_EVENT_ACTIVITY_EDIT,
      props: true,
      component: () => import(
        /* webpackChunkName: "event-activity-success" */
        `@/views/${role}/event-activity/edit.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
